import { useState } from "react";
import { NavLink, Outlet, useLocation, useParams } from "react-router-dom";
import { useAppStore } from "../../stores/RootStore";
import EquipmentsGrid from "./EquipmentsGrid";
import { Separator } from "../../ui/Separator";
import { useTranslation } from "react-i18next";
import { Header } from "../../components/Header";

export const Equipments = () => {
  let {id} = useParams();
  const { t } = useTranslation();
  const location = useLocation();
  const currentSite = useAppStore().currentSite
  const equipments = useAppStore().equipments;

  function empty() {}

  return (
    <div className="flex flex-col w-full h-full bg-muted">
      <div className="flex-none flex w-full h-14 px-6 justify-between items-center bg-background">
        <div className="flex text-base items-center gap-1">
          <NavLink to={"/"}><span className="font-medium">{currentSite?.name ? currentSite?.name : "..."}</span></NavLink>
          <span>/</span>
          {location.pathname == "/data/equipment/" || location.pathname == "/data/equipment" ? <span className="font-medium">{t("equipment")}</span> : <NavLink to={"/data/equipment"}><span className="font-medium">{t("equipment")}</span></NavLink>}
          {(id || location.pathname == "/data/equipment/new") && <span>/</span>}
          {id && <span>{equipments?.find(n => n.id == id)?.attributes.name}</span>}
          {location.pathname == "/data/equipment/new" && <span>{t('adding_equipment')}</span>}
        </div>
      </div>
      <Separator className="flex-none"/>
      {id || location.pathname == "/data/equipment/new" ? 
        <Outlet /> : 
        <div className="flex w-full h-full bg-background">
          <div className="flex flex-col w-full h-full mx-auto overflow-hidden">
            <Header name={t('equipment')} backName={currentSite?.name ? currentSite?.name : "..."} backLink={"/"}/>
            <EquipmentsGrid onClose={empty}/>
          </div>
        </div>
      }
    </div>
  )
};
